(() => {
  if (customElements.get('announcement-countdown')) return;

  const pacificFormatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  const wallTime = (timestamp) => {
    const parts = Object.fromEntries(pacificFormatter.formatToParts(timestamp).map(part => [part.type, part.value]));
    return Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), Number(parts.hour), Number(parts.minute), Number(parts.second));
  };

  class AnnouncementCountdown extends HTMLElement {
    static getDeadline(date, time) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return NaN;
      const [year, month, day] = date.split('-').map(Number);
      const [hour, minute] = time.split(':').map(Number);
      const requested = Date.UTC(year, month - 1, day, hour, minute);
      if (new Date(requested).toISOString().slice(0, 10) !== date) return NaN;
      let deadline = requested;
      for (let attempt = 0; attempt < 3; attempt++) deadline += requested - wallTime(deadline);
      return wallTime(deadline) === requested ? deadline : NaN;
    }

    connectedCallback() {
      this.deadline = AnnouncementCountdown.getDeadline(this.dataset.endDate, this.dataset.endTime);
      if (!Number.isFinite(this.deadline)) return;
      this.values = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-countdown-${unit}]`));
      const deadlineLabel = this.querySelector('[data-countdown-deadline]');
      deadlineLabel.dateTime = new Date(this.deadline).toISOString();
      deadlineLabel.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en', {
        timeZone: 'America/Los_Angeles', dateStyle: 'full', timeStyle: 'long'
      }).format(this.deadline);
      this.update();
      if (!this.hidden) this.interval = setInterval(() => this.update(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    update() {
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      this.hidden = seconds === 0;
      if (this.hidden) clearInterval(this.interval);
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      this.values.forEach((element, index) => { element.textContent = String(values[index]).padStart(2, '0'); });
    }
  }

  customElements.define('announcement-countdown', AnnouncementCountdown);
})();
